import { isJson } from "./isJson";
export const formatMimeType56 = (rawData, text = "") => {
  try {
    const hasRawData =
      Boolean(rawData) &&
      typeof rawData === "object" &&
      "mimetypeid" in rawData &&
      rawData.mimetypeid === 56;
    if (!hasRawData) return text;
    const isMessageAValidJson = isJson(rawData.messagem);
    if (isMessageAValidJson) {
      return JSON.parse(rawData.messagem).URL || text;
    }
    let message_f = rawData.messagem || "";
    let message_fd = message_f
      .replace(/\n/g, "\\n")
      .replace(/\r/g, "")
      .replace(/\\"/g, '"');
    const isMessageFdValidJson = isJson(message_fd);
    if (isMessageFdValidJson) {
      return JSON.parse(message_fd).URL || text;
    }

    return text;
  } catch (error) {
    console.log("formatMimeType56 Error: ", error);
    return text;
  }
};
